import React from "react";
import { Field, useFormState } from "react-final-form";

import { NavigationButton } from "../components/NavigationButton";
import { FormData, FormResources } from "../types/formData";
import { Navigation } from "../types/navigation";
import { getAge } from "../utils/getAge";
import { RadioButtonsContainer } from "../valuation-manager.styles";
import { useValuationManagerContext } from "../ValuationManagerContext";

interface ServiceHistoryPageProps {
  setPageName: (pageName: Navigation) => void;
  formResources: FormResources;
}

export const ServiceHistoryPage: React.FC<ServiceHistoryPageProps> = ({
  setPageName,
  formResources,
}) => {
  const { values }: { values: FormData } = useFormState();
  const { vehicleDetails } = useValuationManagerContext();
  const vehicleAge = vehicleDetails?.registrationDate
    ? getAge(vehicleDetails?.registrationDate)
    : 0;

  return (
    <div>
      <div className="row">
        <RadioButtonsContainer className="col-sm-6 col-md-6 col-lg-6">
          <legend>{formResources.serviceHistory.title}</legend>
          {formResources.serviceHistory.options.map((option) => {
            let disabled = false;
            if (
              option.value === formResources.serviceHistory.options[4].value &&
              vehicleAge >= 3
            ) {
              disabled = true;
            }
            return (
              <div className="radio" key={option.value}>
                <label>
                  <Field
                    name="serviceHistory"
                    component="input"
                    type="radio"
                    value={option.value}
                    required
                    aria-label={option.label + " Service History"}
                    data-testid={option.value + "-option"}
                    disabled={disabled}
                  />
                  {option.label}
                </label>
              </div>
            );
          })}
          <Field name="serviceHistory" subscription={{ value: true }}>
            {({ input: { value } }) => {
              return value && value !== "none" && value !== "notDue" ? (
                <>
                  <div className="form-group">
                    <label>Date of last service</label>
                    <Field
                      name="date_of_last_service"
                      component="input"
                      type="date"
                      className="form-control"
                      data-testid="date_of_last_service"
                    />
                  </div>
                </>
              ) : null;
            }}
          </Field>
        </RadioButtonsContainer>
      </div>
      <NavigationButton
        setPageName={setPageName}
        disabled={!values.serviceHistory}
      />
    </div>
  );
};
